// extracted by mini-css-extract-plugin
export var errorIcon = "_nn-1";
export var nameLogo = "_nn-0";